<template>
  <Card :header="$t('apdex-for-apm-and-browser-monitoring')">
    <template #card-body>
      <div class="chart-container" @click="apdexClick">
        <DonutChart
          :appLabels="labels"
          :apps="applications"
          :loading="loading"
          :customStyle="{ height: '16rem' }"
          @legendClick="handleLegendClick"
          @dataPointSelection="handleDataPointSelection"
        ></DonutChart>
      </div>
    </template>
  </Card>
  <ApdexAppList
    :showModal="showApdexApplist"
    :onClose="onApdexAppListClose"
    v-if="showApdexApplist"
    :apdexApplistStatus="apdexApplistStatus"
  />
</template>
<script>
import Card from '@/rex-components/rex-card.vue';
import DonutChart from '@/components/charts/chart-donut.vue';
import graphQl from '@/services/graphQl';
import { mapGetters } from 'vuex';
import ApdexAppList from '@/components/Home/revamp/ApdexAppList.vue';
import {
  HEALTH_STATUSES,
  APDEX_THRESHOLDS,
} from '@/components/Home/revamp/util.js';
import { parseApdex } from '@/utils/helper-function';

export default {
  components: { Card, DonutChart, ApdexAppList },
  data() {
    return {
      applications: [0, 0, 0],
      loading: false,
      showApdexApplist: false,
      apdexApplistStatus: HEALTH_STATUSES()[0],
    };
  },
  methods: {
    async getData() {
      try {
        const params = {
          condition: {
            name: 'service_apdex',
            entity: {
              scope: 'All',
            },
          },
          duration: this.getDurationTime,
        };
        const {
          data: {
            data: {
              apdex: { apdexes },
            },
          },
        } = await graphQl.query('queryApdexScores').params(params);
        this.applications = [0, 0, 0];
        if (apdexes && Array.isArray(apdexes)) {
          apdexes.forEach((apdex) => {
            const apdexPercentage = parseApdex(apdex.percentage / 10000);
            if (apdexPercentage >= APDEX_THRESHOLDS.Good) {
              this.applications[0]++;
            } else {
              if (apdexPercentage >= APDEX_THRESHOLDS.Fair) {
                this.applications[1]++;
              } else this.applications[2]++;
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.log('error', error);
      }
    },
    apdexClick() {
      this.showApdexApplist = true;
    },
    onApdexAppListClose() {
      this.apdexApplistStatus = HEALTH_STATUSES()[0];
      this.showApdexApplist = false;
    },
    handleLegendClick(_, seriesIndex) {
      this.apdexApplistStatus = HEALTH_STATUSES()[seriesIndex];
    },
    handleDataPointSelection(event, chartContext, config) {
      const seriesIndex = config.dataPointIndex;
      this.apdexApplistStatus = HEALTH_STATUSES()[seriesIndex];
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    getDurationTime(newValue) {
      this.getData();
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    labels() {
      return [this.$t('good'), this.$t('fair'), this.$t('poor')];
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-container {
  display: flex;
  height: 100%;
  width: fit-content;
  cursor: pointer;
}
</style>
